import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Table } from "semantic-ui-react";
import { ActionButtons, Container } from "./styles";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { RiDeleteBinLine } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";

export const MBAList = () => {
  const [mbas, setMbas] = useState([]);

  useEffect(() => {
    api.get("/admin/mba/list").then(response => setMbas(response.data));
  }, []);

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <h1>Lista MBAs (Moldes)</h1>
        <Table>
          <Table.Header>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>ID Curso</Table.HeaderCell>
            <Table.HeaderCell>ID Combo</Table.HeaderCell>
            <Table.HeaderCell>Descrição</Table.HeaderCell>
            {/* <Table.HeaderCell>Ativo</Table.HeaderCell> */}
            <Table.HeaderCell>Editar </Table.HeaderCell>
            {/* <Table.HeaderCell>Editar (Atualização em Massa)</Table.HeaderCell> */}
          </Table.Header>

          <Table.Body>
            {mbas &&
              mbas.map(mba => (
                <Table.Row key={mba.id}>
                  <Table.Cell>{mba.id}</Table.Cell>
                  <Table.Cell>{mba.id_curso}</Table.Cell>
                  <Table.Cell>{mba.id_combo}</Table.Cell>
                  <Table.Cell>{mba.descricao}</Table.Cell>
                  {/* <Table.Cell>{mba.is_active ? "S" : "N"}</Table.Cell> */}
                  <Table.Cell>
                    <ActionButtons>
                      <a href={`/admin/mba/list/${mba.id}`}>
                        <FaRegEdit size={16} color="var(--color-primary)" />
                      </a>
                    </ActionButtons>
                  </Table.Cell>
                  {/* <Table.Cell>
                    <ActionButtons>
                      <a href={`/admin/mba/persist/${mba.id}`}>
                        <FaRegEdit size={16} color="var(--color-primary)" />
                      </a>
                    </ActionButtons>
                  </Table.Cell> */}
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </Container>
    </div>
  );
};
